import tableStore from '../../store/TableStore';
import { WEvent } from './WEvent';

export class WRemoveTableEvent extends WEvent {
  constructor(event: WRemoveTableEvent) {
    super(event.tableId, event.eventType, event.eventTime);
  }

  public applyWebsocketChanges = (): Promise<void> => {
    tableStore.deleteTable(this.tableId);
    return Promise.resolve();
  };
}
